import styled from "styled-components/macro";

import { useGetPaymentTypeVerbiage } from "Payments/PaymentPage/Shared/useGetPaymentTypeVerbiage";

const trimmedTotal = (total) => {
  const isWholeNumber = total.split(".")[1] === "00";

  if (isWholeNumber) return total.split(".")[0];

  return total;
};

const TotalAmount = ({ totalAmount }) => {
  const { verb } = useGetPaymentTypeVerbiage();

  if (!totalAmount) return null;

  return (
    <TotalWrapper>
      Total to {verb}: <span>{trimmedTotal(totalAmount)}</span>
    </TotalWrapper>
  );
};

export default TotalAmount;

const TotalWrapper = styled.div`
  font-weight: 600;
  margin-top: 8px;
  margin-left: 28px;

  @media screen and (max-width: 480px) {
    margin-left: 0;
  }
`;
